let index: number = 0;

const DiscountProgramFormGridPluginSettings: IPluginSettings = {
    name: 'Скидки',
    mnemocode: 'discount_plugin',
    permission: 'DiscountProgram',
    columns: [{
        order: index++,
        propertyName: 'idGlobal',
        propertyType: 'string',
        displayName: 'IdGlobal',
        visibility: false,
        width: 150
    },
    {
        order: index++,
        propertyName: 'name',
        propertyType: 'string',
        displayName: 'Наименование скидки',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'dateCreated',
        propertyType: 'string',
        displayName: 'Дата создания скидки',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'dateStarDisplay',
        propertyType: 'string',
        displayName: 'Дата начала действия скидки',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'dateEndDisplay',
        propertyType: 'string',
        displayName: 'Дата окончания действия скидки',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'discountType',
        propertyType: 'string',
        displayName: 'Тип скидки',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'discountTypeName',
        propertyType: 'string',
        displayName: 'Тип скидки имя',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'discountValue',
        propertyType: 'number',
        displayName: 'Размер скидки',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'conditionJoinType',
        propertyType: 'string',
        displayName: 'Способ объединения условий',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'isAutoCalc',
        propertyType: 'boolean',
        displayName: 'Автоматический расчет скидки',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'isUseMinAdprice',
        propertyType: 'boolean',
        displayName: 'Признак минимальный процент наценки',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'minAdprice',
        propertyType: 'number',
        displayName: 'Значение минимального процента наценки',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'superPosition',
        propertyType: 'string',
        displayName: 'Наложение скидок',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'isSystem',
        propertyType: 'boolean',
        displayName: 'Признак системной скидки',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'infoCashier',
        propertyType: 'string',
        displayName: 'Информация для кассира',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'infoCheque',
        propertyType: 'string',
        displayName: 'Описание маркетинговой акции',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'isSpecialDiscount',
        propertyType: 'boolean',
        displayName: 'Признак специальной скидки',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'specialDiscount',
        propertyType: 'string',
        displayName: 'Наименование процедуры специальной скидки',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'specialDiscountParams',
        propertyType: 'string',
        displayName: 'Параметры процедуры специальной скидки',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'isInfoOnItem',
        propertyType: 'boolean',
        displayName: 'Признак отображения информации для кассира',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'isDisablePrintDiscountText',
        propertyType: 'boolean',
        displayName: 'Признак скрытой скидки',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'barcode',
        propertyType: 'string',
        displayName: 'Штрих-код',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'barcodeEntered',
        propertyType: 'string',
        displayName: 'barcodeEntered',
        visibility: false,
        width: 150
    },
    {
        order: index++,
        propertyName: 'priority',
        propertyType: 'string',
        displayName: 'Приоритет',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'isAllowPartial',
        propertyType: 'boolean',
        displayName: 'Признак частичного применения скидки',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'description',
        propertyType: 'string',
        displayName: 'Настройки отображения описания скидки',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'isShowOnStartup',
        propertyType: 'boolean',
        displayName: 'Признак отображения скидки при старте',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'idReplicationNetwork',
        propertyType: 'string',
        displayName: 'idReplicationNetwork',
        visibility: false,
        width: 150
    },
    {
        order: index++,
        propertyName: 'idRiglaPriceList',
        propertyType: 'string',
        displayName: 'idRiglaPriceList',
        visibility: false,
        width: 150
    },
    {
        order: index++,
        propertyName: 'riglaPriceListName',
        propertyType: 'string',
        displayName: 'riglaPriceListName',
        visibility: false,
        width: 150
    },
    {
        order: index++,
        propertyName: 'isUseMaxDiscount',
        propertyType: 'boolean',
        displayName: 'Признак пересчитывания скидки до максимально возможной',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'dateDeleted',
        propertyType: 'datetime',
        displayName: 'Дата удаления',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'dateModified',
        propertyType: 'datetime',
        displayName: 'Дата изменение',
        visibility: true,
        width: 150
    },
    {
        order: index++,
        propertyName: 'deleted',
        propertyType: 'boolean',
        displayName: 'Удален',
        visibility: false,
        favoriteFilter: false,
        width: 150
    }
    ],
}

export default DiscountProgramFormGridPluginSettings